// Original placeholder logo: document page + waveform dictation line + quality check + letter J.
export function LogoMark({ className = "", tone = "primary" }) {
  const ink = tone === "white" ? "#FFFFFF" : "#176B52";
  const gold = tone === "white" ? "#FFFFFF" : "#D5A63A";
  const soft = tone === "white" ? "rgba(255,255,255,0.5)" : "#0B3D32";
  return (
    <svg className={className} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="8" y="4" width="24" height="32" rx="3" stroke={ink} strokeWidth="2" />
      <path d="M14 13h9" stroke={soft} strokeWidth="2" strokeLinecap="round" />
      {/* waveform dictation line */}
      <path d="M13 21c1.5-3 2.5 3 4 0s2.5 4 4 0 2.5 3 4 0" stroke={ink} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      {/* letter J tail */}
      <path d="M22 26v3.2c0 1.6-1.3 2.8-2.9 2.8" stroke={ink} strokeWidth="2" strokeLinecap="round" />
      {/* quality check */}
      <circle cx="30" cy="30" r="6" fill={gold} />
      <path d="M27.4 30.2l1.7 1.7 3-3.4" stroke={tone === "white" ? "#176B52" : "#0B3D32"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function Logo({ tone = "primary", stacked = false, showDescriptor = false }) {
  const ink = tone === "white" ? "text-white" : "text-brand-ink";
  const muted = tone === "white" ? "text-white/70" : "text-brand-muted";
  return (
    <span className={`inline-flex items-center gap-2.5 ${stacked ? "flex-col !gap-1.5" : ""}`}>
      <LogoMark className="h-9 w-9 shrink-0" tone={tone} />
      <span className="flex flex-col leading-none">
        <span className={`font-heading font-800 tracking-tight text-[19px] ${ink}`}>Primevanta Global</span>
        {showDescriptor && <span className={`text-[11px] tracking-wide ${muted} mt-0.5`}>Documentation &amp; Business Support</span>}
      </span>
    </span>
  );
}
